
import { Model } from './model';
import { ReportSummaryModel } from './report-summary-model';
import { SuiteModel } from './suite-model';
export class ReportModel implements Model{
    browser: string[];
    resolution: string;
    _id: string;
    suite:SuiteModel;
    start_time: any;
    end_time:Date;
    video: string;
    logs: string;
    html: string;
    har: string;
    suite_id: string;
    default_pause: string;
    run_status_text: string
    report_links:{
        logs_report:string,
        html_report:string,
        har_report:string,
        selenoid_link:string,
        video_link:string
        selenoid_links:string[],
        video_links:string[],
        links: {},
        live_status: {}
    }
    summary:ReportSummaryModel;
    hub_ip:string;
    default_hub: boolean;
    local_execution:boolean;
    created_by:string;
    port:number;
    screenshot_required:boolean;
    emulators?:string[];
    scheduled: boolean;
    schedule_id?: string;
}
